export const CHECKOUT_URL = 'https://pay.hotmart.com/D106145393F'

export const PRICE = '$9.990 CLP'
export const PRICE_FULL = '$44.900 CLP'

export const benefits = [
  {
    icon: 'eye',
    title: 'Cuestiona la realidad',
    text: 'Aprende a observar lo que dabas por sentado y empieza a ver lo que estaba oculto a simple vista.',
  },
  {
    icon: 'brain',
    title: 'Identifica la programación mental',
    text: 'Detecta los pensamientos, miedos y creencias que no son tuyos y empieza a soltarlos con claridad.',
  },
  {
    icon: 'expand',
    title: 'Amplía tu perspectiva',
    text: 'Sal del piloto automático y observa tu vida desde una mirada más amplia, más conciente, más libre.',
  },
  {
    icon: 'flame',
    title: 'Reconecta con tu poder interior',
    text: 'Recuerda lo que siempre estuvo dentro de ti: claridad, intuición y la fuerza de elegir.',
  },
  {
    icon: 'shield',
    title: 'Observa el miedo desde otro nivel',
    text: 'Deja de huir y aprende a mirar al miedo de frente para descubrir qué intenta mostrarte.',
  },
  {
    icon: 'compass',
    title: 'Despierta tu propósito',
    text: 'Conéctate con preguntas profundas sobre tu alma, tu camino y el rol que viniste a jugar.',
  },
] as const

export const insideItems = [
  'Reflexiones profundas para cuestionar lo que llamas “realidad”.',
  'Claves para reconocer cómo opera la programación mental cotidiana.',
  'Una mirada sencilla sobre la Matrix, la simulación y el libre albedrío.',
  'Ejercicios introspectivos para observar tu miedo y tus patrones.',
  'Preguntas poderosas para reconectar con tu propósito y tu alma.',
  'Conceptos sobre energía, conciencia y el juego de la vida.',
  'Un lenguaje claro, sin tecnicismos ni promesas exageradas.',
  'Un ritmo que te invita a leer despacio… y a transformarte mientras lo haces.',
]

export const forYouItems = [
  'Sientes que la realidad es más profunda de lo que te muestran.',
  'Estás cansado de vivir en piloto automático y quieres despertar.',
  'Te llaman los temas del despertar, la Matrix, la simulación y la conciencia.',
  'Sientes vacío, rutina o desconexión y no sabes cómo nombrarlo.',
  'Quieres entender de dónde vienen tus miedos y tus pensamientos repetitivos.',
  'Buscas reconectar con tu intuición y tu poder personal.',
  'Te interesa el crecimiento personal desde una mirada más espiritual.',
  'Sospechas que hay un propósito mayor para tu alma… y quieres recordarlo.',
]

export const beforeItems = [
  'Sensación de vacío que no logras explicar.',
  'Vives en rutina, sin saber por qué sigues haciendo lo mismo.',
  'Repites pensamientos y miedos que no eliges.',
  'Sientes que algo te falta… pero no logras nombrarlo.',
  'Cuestionas la realidad y te sientes solo en esas preguntas.',
]

export const afterItems = [
  'Más claridad mental y emocional cada día.',
  'Observas tus pensamientos en lugar de obedecerlos.',
  'Reconoces tu programación y dejas de reaccionar en automático.',
  'Sientes una conexión más profunda con tu propósito.',
  'Tu mirada de la vida se amplía: ya no juegas a ciegas.',
]

export const pricingFeatures = [
  'Descarga al instante después de comprar',
  'Léelo desde tu celular, tablet o computador',
  'Acceso ilimitado, sin caducidad',
  'Pago 100% seguro a través de Hotmart',
]

export const faqs = [
  {
    q: '¿Cómo recibo el eBook después de comprarlo?',
    a: 'Apenas se confirme tu compra en Hotmart, recibirás un correo con el acceso inmediato al eBook en formato digital. Podrás descargarlo y comenzar a leerlo al instante, sin esperas ni envíos físicos.',
  },
  {
    q: '¿El pago es seguro?',
    a: 'Sí. El pago se procesa completamente dentro de Hotmart, una plataforma internacional de productos digitales con cifrado y protección de datos. Nunca tenemos acceso a los datos de tu tarjeta.',
  },
  {
    q: '¿Puedo leerlo desde el celular?',
    a: 'Sí. El eBook está pensado para leerse cómodamente desde el celular, la tablet o el computador. Descárgalo una vez y léelo donde quieras, incluso sin conexión.',
  },
  {
    q: '¿Este libro es para principiantes en temas de conciencia?',
    a: 'Sí. Está escrito en un lenguaje claro y sin tecnicismos. Si recién empiezas, será una puerta de entrada simple; si ya llevas camino recorrido, encontrarás preguntas que profundizan tu mirada.',
  },
  {
    q: '¿Cuánto cuesta?',
    a: 'El valor normal es de $44.900 CLP, pero hoy puedes acceder por $9.990 CLP. Es un pago único, sin suscripciones ni cobros posteriores, con acceso para siempre.',
  },
  {
    q: '¿En qué formato viene el eBook?',
    a: 'Es un eBook digital en PDF, optimizado para leerse en cualquier dispositivo. No incluye envío físico: todo el acceso es inmediato y online.',
  },
]
